function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: 1.5,
  d: "M20.656 17.592v0l.282-10.794v0L11.067 1.07v0L1.07 6.878v10.896l9.971 7.045v0l9.615-7.227v0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: 1.5,
  d: "M11.05 24.82v0l.026-11.874v0L20.937 6.8v0M11.077 12.947L1.09 6.88"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: 1.5,
  d: "M5.53 9.575L15.587 3.69"
}));

var SvgPackage = function SvgPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 26"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDIyIDI2Ij48Zz48Zz48Zz48Zz48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjUwIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0iTTIwLjY1NiAxNy41OTJ2MGwuMjgyLTEwLjc5NHYwTDExLjA2NyAxLjA3djBMMS4wNyA2Ljg3OHYxMC44OTZsOS45NzEgNy4wNDV2MGw5LjYxNS03LjIyN3YwIi8+PC9nPjxnPjxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iNTAiIHN0cm9rZS13aWR0aD0iMS41IiBkPSJNMTEuMDUgMjQuODJ2MGwuMDI2LTExLjg3NHYwTDIwLjkzNyA2Ljh2MCIvPjwvZz48Zz48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjUwIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0iTTExLjA3NyAxMi45NDdMMS4wOSA2Ljg4Ii8+PC9nPjwvZz48Zz48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjUwIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0iTTUuNTMgOS41NzVMMTUuNTg3IDMuNjkiLz48L2c+PC9nPjwvZz48L3N2Zz4=";
export { SvgPackage as ReactComponent };